import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoute } from '@/components/ProtectedRoute';

const Index = lazy(() => import("@/features/customer/pages/Index"));
const Auth = lazy(() => import("@/features/auth/pages/Auth"));
const ResetPassword = lazy(() => import("@/features/auth/pages/ResetPassword"));
const NotFound = lazy(() => import("@/pages/NotFound"));

export const publicRoutes = (
  <>
    <Route path="/" element={
      <ProtectedRoute requireAuth={false}>
        <Index />
      </ProtectedRoute>
    } />
    <Route path="/auth" element={<Auth />} />
    <Route path="/reset-password" element={<ResetPassword />} />
    <Route path="*" element={<NotFound />} />
  </>
);
